import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=2e97f2c0&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=js&"
export * from "./Token.vue?vue&type=script&lang=js&"
import style0 from "./Token.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Token.vue?vue&type=style&index=1&id=2e97f2c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e97f2c0",
  null
  
)

export default component.exports